"use client";
import AlgoliaProvider from "@components/algolia/AlgoliaProvider";
import { STORES_LIMIT } from "@components/try-and-buy/constants";
import { activeSiteConfig } from "@config/site/site-config";
import { useGetUserPosition } from "@hooks/useGetUserPosition";
import { useAuth } from "@lib/auth/useAuth";
import { getUserPositionCoords } from "@lib/utils/getUserPositionCoords";
import { useLocale } from "next-intl";
import type { PropsWithChildren } from "react";
import { memo, useState } from "react";

type Props = { isOpen: boolean } & PropsWithChildren;

export const StoresProvider = memo(function Provider({ isOpen, children }: Props) {
    const locale = useLocale();
    const { country } = activeSiteConfig;
    const [aroundLatLng, setAroundLatLng] = useState(undefined);
    const { isLoggedIn } = useAuth();

    const successCallback: PositionCallback = (position) => {
        const { latitude, longitude } = getUserPositionCoords(position);
        setAroundLatLng(`${latitude},${longitude}`);
    };

    const errorCallback = () => {
        setAroundLatLng(undefined);
    };

    const isEligible = isLoggedIn && isOpen;
    useGetUserPosition({
        isEligible,
        successCallback,
        errorCallback,
    });

    return (
        <AlgoliaProvider
            hitsPerPage={STORES_LIMIT}
            aroundLatLng={aroundLatLng}
            mode="stores"
            facetFilters={["reserveInStore:true", `country:${country}`]}
            locale={locale}
            minBlockSize={0}
        >
            {children}
        </AlgoliaProvider>
    );
});
